import { ReadonlyURLSearchParams } from "next/navigation";
import {
  AVAILABILITY_PRIORITY,
  FILTER_CATEGORIES,
} from "@/components/Search/constants";
import { getMappedSearchParams } from "@/components/Search/utils/mapFacetParams";

const ARCHIVED_AVAILABILITY_FACET = AVAILABILITY_PRIORITY.find(
  (value) => value === "Archived",
);

export function shouldExcludeOnlyArchivedCourseRuns(
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
  indexName: string,
): boolean {
  if (!ARCHIVED_AVAILABILITY_FACET) {
    return true;
  }
  const availability =
    getRefinementListFromSearchParams(searchParams, indexName).availability ??
    [];
  return !availability.includes(ARCHIVED_AVAILABILITY_FACET);
}

function refinementListFromParamsArray(
  paramsArray: Array<[string, string]>,
): Record<string, string[]> {
  const params: { [key: string]: string[] } = {};
  paramsArray.forEach(([key, value]: [string, string]) => {
    if (params[key]) {
      params[key].push(value);
    } else {
      params[key] = [value];
    }
  });

  const refinements: Record<string, string[]> = {};
  FILTER_CATEGORIES.forEach((facet) => {
    if (params[facet]) {
      refinements[facet] = params[facet];
    }
  });
  return refinements;
}

/**
 * Facet refinements implied by the current URL, using the same mapping as initial InstantSearch state.
 */
export function getRefinementListFromSearchParams(
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
  indexName: string,
): Record<string, string[]> {
  const { paramsArray } = getMappedSearchParams(searchParams, indexName);
  return refinementListFromParamsArray(paramsArray);
}

/** Same as getRefinementListFromSearchParams when you already have mapped `paramsArray`. */
export function getRefinementListFromMappedParamsArray(
  paramsArray: Array<[string, string]>,
): Record<string, string[]> {
  return refinementListFromParamsArray(paramsArray);
}
